import { NgModule } from '@angular/core';
import { SatisfactorComponent } from './satisfactor.component';
import { UserSurveyModel }  from './user-survey.model';

@NgModule({
  declarations: [SatisfactorComponent],
  imports: [
  ],
  exports: [
    SatisfactorComponent,
  ]
})
export class SatisfactorModule { }
